<template>
  <div class="home">
    <v-row class="justify-center" v-if="!$store.state.showMenu">
      <v-col cols="12" sm="6" md="4" lg="4" class="d-flex align-stretch pa-1">
        <v-card class="flex-grow-1">
          <div class="row mr-4 mt-2">
            <v-spacer></v-spacer>
            <v-btn icon @click="$router.go(-1)">
              <v-icon>fa-solid fa-reply</v-icon>
            </v-btn>
          </div>
          <v-card-subtitle class="title text-center"
            >Bem-vindo(a) {{ userName }}!<br />O que você deseja
            fazer?</v-card-subtitle
          >
          <v-card-text class="text--primary mt-6 mb-6 justify-center">
            <v-btn block outlined color="primary" class="mt-2" to="/planos"
              ><v-icon left>fas fa-user-md</v-icon> MEUS PLANOS</v-btn
            >
            <v-btn block outlined color="primary" class="mt-2" to="/relatorios"
              ><v-icon left>fas fa-dollar-sign</v-icon> RELATÓRIOS</v-btn
            >
            <v-btn block outlined color="primary" class="mt-2" to="/boletos"
              ><v-icon left>fas fa-barcode</v-icon> 2ª VIA DE BOLETOS</v-btn
            >
            <v-btn block outlined color="primary" class="mt-2" to="/carteirinha"
              ><v-icon left>fa-duotone fa-id-card</v-icon> 2ª VIA DE
              CARTEIRINHA</v-btn
            >
            <v-btn
              block
              outlined
              color="primary"
              class="mt-2"
              to="/dadoscadastrais"
              ><v-icon left>fa-solid fa-users-gear</v-icon> DADOS CADASTRAIS</v-btn
            >
            <v-btn
              block
              outlined
              color="primary"
              class="mt-2"
              @click="$store.dispatch('request/logout')"
              ><v-icon left>fa-light fa-right-from-bracket</v-icon> SAIR</v-btn
            >
          </v-card-text>
          <v-card-actions> </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <router-view v-if="$store.state.showMenu" />
  </div>
</template>

<script>
export default {
  computed: {
    userName() {
      return this.$store.state.plans.userName.split(" ")[0] || "visitante";
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name == "home") {
      this.$store.commit("toggleMenu", "hide");
    } else {
      this.$store.commit("toggleMenu", "show");
    }
    next();
  },
  created() {
    let _this = this;
    if (
      !this.$store.state.plans.plans.length &&
      localStorage.corporeExpireToken > new Date().getTime()
    ) {
      let userData = {
        token: localStorage.corporeToken,
        cpf: localStorage.corporeUserId,
      };
      this.$store.dispatch("request/getUserPlans", userData).then((_) => {
        return true;
      });
    } else if (localStorage.corporeExpireToken <= new Date().getTime()) {
      _this.$router.push("/login");
    }
  },
};
</script>

<style>
.title {
  font-weight: normal !important;
}
</style>
